import { useEffect, useState } from "react";
import { api, type SessionResponse } from "./api";
import { Dashboard } from "./components/Dashboard";
import { Login } from "./components/Login";
import { ToastProvider } from "./components/ToastProvider";

type AuthState = "loading" | "authenticated" | "unauthenticated";

export function App() {
  const [authState, setAuthState] = useState<AuthState>("loading");

  useEffect(() => {
    let cancelled = false;

    async function checkSession() {
      try {
        const session = await api<SessionResponse>("/api/session");
        if (!cancelled) {
          setAuthState(session.authenticated ? "authenticated" : "unauthenticated");
        }
      } catch {
        if (cancelled) return;
        setAuthState("unauthenticated");
      }
    }

    void checkSession();

    return () => {
      cancelled = true;
    };
  }, []);

  if (authState === "loading") {
    return <main className="min-h-screen bg-[#120f0c]" aria-label="Loading SubMonitor" />;
  }

  if (authState === "unauthenticated") {
    return (
      <ToastProvider>
        <Login onAuthenticated={() => setAuthState("authenticated")} />
      </ToastProvider>
    );
  }

  return (
    <ToastProvider>
      <Dashboard />
    </ToastProvider>
  );
}
